import React from "react";
import _ from "lodash";
import { ReactComponent as CheckBoxEnabledSvg } from "../../../assets/images/opt/checkbox-enabled.svg";
import { ReactComponent as CheckBoxDisabledSvg } from "../../../assets/images/opt/checkbox-disabled.svg";

const Filter = ({
  sortArray,
  filterArray,
  onSelectSort,
  convertedTime,
  onSelectFilter
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()} className="filter-dropdown">
      <h2>Sort:</h2>
      {!_.isEmpty(sortArray) &&
        sortArray.map((item, index) => (
          <div
            key={index}
            className={`sort-type ${item.selected ? "selected" : ""}`}
            onClick={() => onSelectSort(item)}
          >
            {item.value}
          </div>
        ))}
      <h2>Filter:</h2>
      <div className="filter-type">
        {!_.isEmpty(filterArray) &&
          filterArray.map((filter, index) => (
            <div
              key={index}
              className="input-filter"
              onClick={() => onSelectFilter(filter)}
            >
              {filter.selected ? (
                <CheckBoxEnabledSvg className="checkbox" />
              ) : (
                <CheckBoxDisabledSvg className="checkbox" />
              )}
              <h3 className="">
                {filter.key === "duration"
                  ? convertedTime(filter.value)
                  : filter.value}
              </h3>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Filter;
